import { useQuery } from "@tanstack/react-query";
import { useAxios } from "@/utils/hooks/useAxios";
import { filterObject } from "@/utils/helpers";

const ACTIVITY_LOGS_BASE = "activity-logs";

export const useActivityLogsQuery = (params = {}, options = {}) => {
  const { axiosProtected } = useAxios();
  const filteredParams = filterObject(params);

  return useQuery({
    queryKey: ["activity-logs", filteredParams],
    queryFn: () =>
      axiosProtected.get(ACTIVITY_LOGS_BASE, {
        params: filteredParams,
      }),
    ...options,
  });
};
